export const WorkResponsibilityParty = {
  broker: 'broker',
  borgo: 'borgo',
} as const

export type WorkResponsibilityParty = (typeof WorkResponsibilityParty)[keyof typeof WorkResponsibilityParty]

// TODO use metadata endpoint instead of hardcoding these labels
export const WORK_RESPONSIBILITY_PARTY_LABELS: Record<WorkResponsibilityParty, string> = {
  broker: 'Förmedlare',
  borgo: 'Borgo',
}
